import gql from 'graphql-tag';

export const CREATE_APPLICATION = gql`
  mutation ($applicantId: ID!, $status: String!) {
    createApplication(input: { applicant: $applicantId, status: $status }) {
      _id
    }
  }
`;
